import { Flex, Text, utils } from "@thenounproject/lingo-core";
import styled from "styled-components";
import { SUB_NAV_WIDTH } from "../../constants/layouts";

export const SubNavContainer = styled(Flex).attrs({
  height: "100%",
  background: "white",
  borderRight: "1px solid border",
  flex: `0 0 ${SUB_NAV_WIDTH}px`,
  pt: "l",
  width: `${SUB_NAV_WIDTH}px`,
})`
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  overflow: visible;
  @media (max-width: 768px) {
    display: none;
  }
`;

export const SubNavWrapper = styled(Flex).attrs({
  flexGrow: 1,
  flexDirection: "column",
  overflow: "hidden",
})``;

export const SubNavTitle = styled(Text).attrs({
  as: "h1",
  font: "ui.title",
  px: "l",
  pb: "s",
})``;

export const SubNavButton = styled.button<{ active: boolean }>`
  width: 100%;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.3s ease;
  color: ${utils.getColor("black")};
  text-align: left;
  background: ${props => utils.getColor(props.active ? "grayLight" : "white")};
  position: relative;
  ${props => utils.getFont("ui.regular", null, props)};

  &:hover {
    background: ${utils.getColor("grayLight")};
  }
`;
